module.exports = __webpack_public_path__ + "img/icon-check.871877fb.svg";